<app-header title="Group Details" [progressvalue]="33" routeName="wbquote"></app-header>
<div class="wb-coverage-wrapper wb-full-height">

  <section class="wb-coverage-content">

    <div class="max-size-wrapper">




      <form [formGroup]="groupform" novalidate class="form-margin">
        <div class="grid-x wb-app-align">
          <div class="cell medium-8 large-8">

            <mat-form-field
              class="form-element mdl-textfield mdl-js-textfield mdl-textfield--floating-label is-upgraded">
              <input matInput [matAutocomplete]="groupDetailsAutocomplete" [(ngModel)]="group.groupName"
                class="mdl-textfield__input" placeholder="Group Name" formControlName="groupName" id="GroupName"
                (ngModelChange)="groupNameDetailEvent.next(group.groupName)" maxlength="50" maxlength="50">

              <mat-autocomplete #groupDetailsAutocomplete="matAutocomplete">
                <mat-option (onSelectionChange)="onGroupSelect(groupDetail)" *ngFor="let groupDetail of groupDetails"
                  [value]="groupDetail.Name">
                  {{ groupDetail.Name }}
                </mat-option>
              </mat-autocomplete>

              <mat-error align="start" class="form__error">Group Name is required</mat-error>
            </mat-form-field>

          </div>
        </div>

        <div class="grid-x wb-app-align">
          <div class="cell medium-8 large-8">

            <mat-form-field
              class="form-element mdl-textfield mdl-js-textfield mdl-textfield--floating-label is-upgraded">
              <input matInput [matAutocomplete]="sicCodeAutoComplete" formControlName="sicCode"
                [(ngModel)]="group.SicCode" class="mdl-textfield__input" placeholder="SIC Code"
                (ngModelChange)="getSICCodes(group.SicCode)" (keydown.Tab)="selectFirstCodeOnTab()"
                (blur)="setSicCodeOnBlur()">


              <mat-error align="start" class="form

                      __error" *ngIf="groupform.get('sicCode').hasError('required')">SIC
                Code is required</mat-error>
              <mat-error align="start" class="form__error"
                *ngIf="groupform.get('sicCode').hasError('sicCodeInValidError')">
                Please enter the SIC Code of this Group or enter a description of this Group, when you see
                the
                appropriate SIC Code, select it.
              </mat-error>


            </mat-form-field>

            <mat-autocomplete [autoActiveFirstOption]="true" #sicCodeAutoComplete="matAutocomplete">
              <mat-option (onSelectionChange)="onSicCodeSelect(sicCode)" *ngFor="let sicCode of sicCodes"
                [value]="setSicCode(sicCode)">
                {{ sicCode.Code }} ({{sicCode.Description}})
              </mat-option>
            </mat-autocomplete>

          </div>
        </div>

        <div class="grid-x wb-app-align">
          <div class="cell medium-8 large-8">

            <mat-form-field
              class="form-element mdl-textfield mdl-js-textfield mdl-textfield--floating-label is-upgraded">
              <input matInput [(ngModel)]="group.ZipCode" class="mdl-textfield__input" placeholder="Zip Code"
                formControlName="zipCode" maxlength="5" id="zipcode" (blur)="getQuotableDates()">

              <mat-error align="start"
                *ngIf="groupform.get('zipCode').hasError('required')|| groupform.get('zipCode').hasError('minlength')"
                class="form__error">
                Zip Code (5 Digit) is required
              </mat-error>
              <mat-error align="start" *ngIf="groupform.get('zipCode').hasError('zipCodeValidError')"
                class="form__error">
                This is not a valid Zip Code
              </mat-error>
              <mat-error align="start" *ngIf="groupform.get('zipCode').hasError('zipCodeStateValidError')"
                class="form__error">
                This is not a
                <span *ngIf="this.group.StateCode != 'CA'">California</span>
                <span *ngIf="this.group.StateCode  != 'NV'">Nevada</span> Zip Code
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="grid-x wb-app-align">
          <div class="cell">
            <div class="controls toggle inline-controlss">
              <mat-chip-list class="mat-chip-list-effective-date">
                <mat-chip class="date-chip chip" [selected]="group?.CountyCode===postalcode?.CountyCode"
                  *ngFor="let postalcode of zipCodes; let i=index" (click)="setCounty(postalcode)">
                  {{postalcode.County}}, {{postalcode.StateName}}
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </div>
        <div class="grid-x wb-app-align">
          <div class="cell ">
            <h3>Effective Date</h3>
            <div class="controls toggle">
              <mat-chip-list class="mat-chip-list-effective-date">
                <mat-chip class="date-chip chip" [selected]="isSelectedEffectiveDate(quotableDate)"
                  *ngFor="let quotableDate of quotableDates; let i=index" (click)="group.EffectiveDate=quotableDate"
                  [attr.data-qaauto]="quotableDate">{{quotableDate}}
                </mat-chip>
              </mat-chip-list>
              <mat-error align="start"
                *ngIf="(quotableDates != undefined && ( group.EffectiveDate==null || group.EffectiveDate=='') && showEffectiveDateError)"
                class="form__error">Effective Date is required</mat-error>
            </div>
          </div>

        </div>
        <!-- <div class="wab-quote-next-button">
                  <a class="wb-button wb-footer mdl-button mdl-js-button desktop-next-button no-text-transform" (click)="saveGroupinfo()">Next</a>
                </div> -->

        <!-- <div class="wab-quote-next-button  rightButton">
                  <a class="wb-button wb-footer mdl-button mdl-js-button desktop-next-button no-text-transform" (click)="saveGroupinfo()">

                    <i class="material-icons">keyboard_arrow_right</i>
                  </a>
                </div> -->

      </form>
    </div>
  </section>
</div>

<footer class="wb-coverage-footer">
  <div class="max-size-wrapper">
    <button class="wb-button mdl-button mdl-js-button" (click)=saveGroupinfo()>
      Next
    </button>
  </div>
</footer>